/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AppendContactsCompanyRequestFromJSON(json) {
    return AppendContactsCompanyRequestFromJSONTyped(json, false);
}
export function AppendContactsCompanyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contactIds: !exists(json, 'contact_ids') ? undefined : json['contact_ids']
    };
}
export function AppendContactsCompanyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact_ids: value.contactIds
    };
}
